import { useEffect } from 'react';
import { reaction } from 'mobx';
import { useUserSettingsContext } from 'contexts';
import { selectLocalParticipant } from 'state/selectors';
import { roomInfoStore } from 'state/store';
import { stopMicIfHardLocked } from './webinarStatus';

/** Выключает микрофон, когда в настройках вебинара включена блокировка аудио. */
export const useWebinarForceMicOff = () => {
    const { setAudioEnabled } = useUserSettingsContext();

    useEffect(
        () =>
            reaction(
                () => ({
                    microDisabled: Boolean(roomInfoStore.metadata?.webinarMode?.microDisabled),
                    webinarEnabled: Boolean(roomInfoStore.metadata?.webinarMode?.enabled),
                    local: selectLocalParticipant(),
                    isMicrophoneEnabled: selectLocalParticipant()?.isMicrophoneEnabled ?? false,
                }),
                ({ local }) => {
                    if (!local) return;
                    stopMicIfHardLocked(local, setAudioEnabled);
                },
                { fireImmediately: true },
            ),
        [setAudioEnabled],
    );
};
